import { Permission } from '@models';

export interface PermissionResult {
  checkUserPermissions: Permission[];
}
